import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';

interface ComingSoonProps {
  title: string;
  description?: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Coming soon</p>
          <p className="text-sm text-gray-700 dark:text-gray-200">{description || 'This feature is under development.'}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComingSoon;

